import { connect } from 'react-redux';
import UploadProfile from 'views/register/uploadProfile/UploadProfile';

const mapDispatchToProps = {};

export default connect(null, mapDispatchToProps)(UploadProfile);